import { api } from '../../../lib/api'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED'

export const UPDATE_USER_PICTURE_REQUEST = 'UPDATE_USER_PICTURE_REQUEST'
export const UPDATE_USER_PICTURE_SUCCESS = 'UPDATE_USER_PICTURE_SUCCESS'
export const UPDATE_USER_PICTURE_FAILED = 'UPDATE_USER_PICTURE_FAILED'

export const updateProfile = function (data, onComplete, fieldGroup = null) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_USER_REQUEST
    })
    api.updateUser(data).then(updateUserResponse => {
      dispatch({
        type: UPDATE_USER_SUCCESS,
        payload: updateUserResponse
      })
      onComplete()
    }).catch(error => {
      dispatch({
        type: UPDATE_USER_FAILED,
        error,
        fieldGroup
      })
    })
  }
}

export const updateUserProfilePicture = function (profilePicture) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_USER_PICTURE_REQUEST
    })
    api.updateUserProfilePicture(profilePicture).then(updateUserResponse => {
      dispatch({
        type: UPDATE_USER_PICTURE_SUCCESS,
        payload: updateUserResponse
      })

    }).catch(error => {
      dispatch({
        type: UPDATE_USER_PICTURE_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/profile/update-profile.js